var Handlebars = require("../../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, helper, options, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    }, buffer = "";

  stack1 = ((helper = (helper = lookupProperty(helpers,"tagList") || (depth0 != null ? lookupProperty(depth0,"tagList") : depth0)) != null ? helper : container.hooks.helperMissing),(options={"name":"tagList","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":12,"column":8},"end":{"line":14,"column":20}}}),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),options) : helper));
  if (!lookupProperty(helpers,"tagList")) { stack1 = container.hooks.blockHelperMissing.call(depth0,stack1,options)}
  if (stack1 != null) { buffer += stack1; }
  return buffer;
},"2":function(container,depth0,helpers,partials,data) {
    var alias1=container.lambda, alias2=container.escapeExpression;

  return "                <a href=\"/search/magazine/tag/"
    + alias2(alias1(depth0, depth0))
    + "\" class=\"link_tag\"><span class=\"txt_tag\">&#35;</span> "
    + alias2(alias1(depth0, depth0))
    + "</a>\n";
},"4":function(container,depth0,helpers,partials,data) {
    return "        <div class=\"txt_empty_result\">검색 결과가 없습니다.</div>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"tit_related_tag\">\n        <span class=\"tit_search\">관련 태그</span>\n        <span class=\"set_tag_more\">\n                <span class=\"ico_bar\"></span>\n                <a class=\"txt_more\" href=\"javascript:;\"><em class=\"tit_more\">더보기</em>\n                    <span><button type=\"button\" class=\"ico_brunch btn_open\" id=\"more_tag\">태그 더보기</button></span>\n                </a>\n        </span>\n        <div class=\"tag_btm\"></div>\n</div>\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"tagList") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(4, data, 0),"data":data,"loc":{"start":{"line":11,"column":0},"end":{"line":17,"column":7}}})) != null ? stack1 : "")
    + "<div class=\"bottom_bar\"></div>";
},"useData":true});